import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {isPlatformBrowser} from '@angular/common';

const SOCIAL_ICONS_FILES = {
    facebook: 'facebook-svgrepo-com.svg',
    instagram: 'instagram-svgrepo-com.svg',
    linkedin: 'linkedin-svgrepo-com.svg',
    twitter: 'twitter-svgrepo-com.svg',
    whatsapp: 'whatsapp-svgrepo-com.svg',
};

@Injectable({ providedIn: 'root' })
export class IconsService {
    constructor() {
        const platformId = inject(PLATFORM_ID);

        if (isPlatformBrowser(platformId)) {
            const domSanitizer = inject(DomSanitizer);
            const matIconRegistry = inject(MatIconRegistry);

            matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-twotone.svg'));
            matIconRegistry.addSvgIconSetInNamespace('mat_outline', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-outline.svg'));
            matIconRegistry.addSvgIconSetInNamespace('mat_solid', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-solid.svg'));
            matIconRegistry.addSvgIconSetInNamespace('feather', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/feather.svg'));
            matIconRegistry.addSvgIconSetInNamespace('heroicons_outline', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-outline.svg'));
            matIconRegistry.addSvgIconSetInNamespace('heroicons_solid', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-solid.svg'));
            matIconRegistry.addSvgIconSetInNamespace('heroicons_mini', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-mini.svg'));



            const socialIcons = [
                'facebook',
                'instagram',
                'linkedin',
                'twitter',
                'whatsapp',
            ];

            socialIcons.forEach(platform => {
                matIconRegistry.addSvgIcon(
                    `${platform}`,
                    domSanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${platform}-svgrepo-com.svg`)
                );
            });
        }
    }
}
